import React, { useState } from 'react';
import { Form, Input, InputNumber, DatePicker, Button, Table, message, Spin } from 'antd';
import axios from 'axios';
import moment from 'moment';
import { app } from '../config';

const FacialScanViewAll = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [showTable, setShowTable] = useState(false);
const [rewardCount, setRewardCount] = useState(0);
  const handleSubmit = async (values) => {
    try {
      setLoading(true);

      const payload = {
        email: values.email,
        scanCounts: values.scanCounts,
        date: values.date ? values.date.format('YYYY-MM-DD') : null,
        // date: values.date ? moment(values.date).format('YYYY-MM-DD') : null,
      };
        console.log("payload",payload)
// return
      // Replace with your API endpoint
      const response = await axios.get(`${app.URL}/api/v1/static/addfacialreward?isWeb=true&email=${payload.email}&facialScans=${payload.scanCounts}&expiryDays=${payload.date}`);
    //   const response = await axios.get(`http://localhost:3200/api/v1/static/addfacialreward?isWeb=true&email=${payload.email}&facialScans=${payload.scanCounts}&expiryDays=${payload.date}`);

      /*
        Expected Response Examples:

        WITH DATA:
        {
          success: true,
          data: [...]
        }

        WITHOUT DATA:
        {
          success: true,
          data: []
        }
      */
if (response?.data?.data && response?.data?.data?.length > 0) {
  setTableData(response.data.data);
  setRewardCount(response?.data?.rewardCount || 0);
  setShowTable(true);

  message.success('Data fetched successfully');
} else {
  setTableData([]);
  setShowTable(false);

  message.success(response?.data?.message || 'Submitted successfully');
}
    //   if (response?.data?.data && response?.data?.data?.length > 0) {
    //     setTableData(response.data.data);
    //     setShowTable(true);

    //     message.success('Data fetched successfully');
    //   }

      form.resetFields();
    } catch (error) {
      console.log(error);
  setTableData([]);
  setShowTable(false);
        setRewardCount(0);
      message.error(error?.response?.data?.result?.msg || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

//   const columns = [
//     {
//       title: 'Email',
//       dataIndex: 'email',
//       key: 'email',
//     },
//     {
//       title: 'Scan Counts',
//       dataIndex: 'scanCounts',
//       key: 'scanCounts',
//     },
//     {
//       title: 'Date',
//       dataIndex: 'date',
//       key: 'date',
//       render: (text) => (text ? moment(text).format('YYYY-MM-DD') : '-'),
//     },
//   ]
      
      const columns = [
        // {
        //   title: 'Reward ID',
        //   dataIndex: 'rewardId',
        //   key: 'rewardId',
        // },
        // {
        //   title: 'Patient ID',
        //   dataIndex: 'patientId',
        //   key: 'patientId',
        // },
        // {
        //   title: 'Reward Type ID',
        //   dataIndex: 'rewardTypeId',
        //   key: 'rewardTypeId',
        // },
        {
          title: 'Scan Count',
          dataIndex: 'scanCount',
          key: 'scanCount',
        },
        {
          title: 'Expiry Date',
          dataIndex: 'expiredAt',
          key: 'expiredAt',
          render: (text) => (text ? moment(text).format('YYYY-MM-DD') : '-'),
        },
        // {
        //   title: 'Created At',
        //   dataIndex: 'createdAt',
        //   key: 'createdAt',
        //   render: (text) => (text ? moment(text).format('YYYY-MM-DD HH:mm') : '-'),
        // },
      ];;

  return (
    <div className='dashboard-card container-fluid'>
      <div className='row p-0 mb-4'>
        <div
          className='for-before col-12 col-lg-6 col-md-8 head fs-3 fw-bold p-3'
          style={{
            // backgroundColor: '#a7c1d9',
            borderBottomRightRadius: '10px',
            color: '#FFFFFF',
          }}
        >
          Facial Scans
        </div>
      </div>

      <div className='row'>
        <div className='col-12'>
          <Form form={form} layout='vertical' onFinish={handleSubmit}>
            <div className='row'>
              <div className='col-12 col-md-4'>
                <Form.Item
                  label='Email'
                  name='email'
                  rules={[
                    {
                      required: true,
                      message: 'Please enter email',
                    },
                    {
                      type: 'email',
                      message: 'Please enter valid email',
                    },
                  ]}
                >
                  <Input placeholder='Enter email' size='large' />
                </Form.Item>
              </div>

              <div className='col-12 col-md-4'>
                <Form.Item
                  label='Scan Counts'
                  name='scanCounts'
                  rules={[
                    {
                      required: true,
                      message: 'Please enter scan counts',
                    },
                  ]}
                >
                  <InputNumber placeholder='Enter scan counts' size='large' style={{ width: '100%' }} min={1} />
                </Form.Item>
              </div>

              <div className='col-12 col-md-4'>
                <Form.Item
                  label='Expiry Date'
                  name='date'
                  rules={[
                    {
                      required: true,
                      message: 'Please select date',
                    },
                  ]}
                >
                  <DatePicker style={{ width: '100%' }} size='large' />
                </Form.Item>
              </div>
            </div>

            <Form.Item>
              <Button type='primary' htmlType='submit' loading={loading} size='large'>
                Submit
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>

      {loading ? (
        <div className='text-center mt-4'>
          <Spin size='large' />
        </div>
      ) : (
        <>
          {/* {showTable && (
            <div className='row mt-4'>
              <div className='col-12'>
                <Table columns={columns} dataSource={tableData} rowKey={(record, index) => index} bordered pagination={{ pageSize: 10 }} />
              </div>
            </div>
          )} */}

          {showTable && (
            <div className='row mt-4'>
              <div className='col-12'>
                <div className='mb-3 fs-5 fw-bold'>Total Reward Count: {rewardCount}</div>

                <Table columns={columns} dataSource={tableData} rowKey='rewardId' bordered pagination={{ pageSize: 10 }} />
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default FacialScanViewAll;
